import { useEffect, useRef, useState } from "react";
import {
  Container,
  ContainerV2,
  ContainerView,
  DesktopContainer,
  MobileContainer,
} from "../../components/Container";
import { useApp } from "../../contexts";
import { TitleWithBackWallet } from "../../components/Layout";

import {
  InfoIcon,
  WalletDetailHeader,
  WalletDetailHeaderLeft,
  WalletDetailHeaderLeftContent,
  WalletDetailHeaderLeftIcon,
  WalletDetailHeaderRight,
  BalanceText,
  BalanceContainer,
  BalanceTitle,
  BalanceValue,
  BalanceValueBTC,
  BalanceValueEqual,
  BalanceValueIcon,
} from "./styles";
import {
  BalanceIcon,
  EqualIcon,
  EqualIcon3,
  EyeIcon,
  IconHideAmount,
  NoEyeIcon,
} from "../wallet-list/styles";
import { ModalCreateWalletSuccess } from "./components/transaction-history/ModalCreateWalletSuccess"
import { ContainerTab, ContainerSubTab, TabItem, TabItemColor } from "../../components/Tab";
import { InfoTooltipIcon } from "../../pages/Home/styles";
import { Divider, Form, Tooltip } from "antd";
import {
  formatCurrency,
  getWallet,
  getWalletList,
  getWalletListSzt,
  getDexWallet,
  getWalletListSgt,
  getSettingByCode,
  roundNumber,
  createDexWallet,
  getWalletOptionDetail,
} from "../../services/app";
import ModalPhoneVerify from "./modal";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { DetailBalance } from "./detail-balance";
import { CountryCode, TYPE_WALLET_DETAIL } from "../../constants";
import TransactionHistory from "./components/transaction-history";
import FormButton from "../../components/FormCustom2/Button";
import { ModalDeposit } from "./ModalDeposit";
import * as Notification from "../../Notification"
import { getCoinCodeImage } from "../../utils/helper";
import { useWindowSize } from "../../hook/useWindowSize";

const defaultValueMLM = {
  possibleBalanceSZT: 0,
  frozenBalanceSZT: 0,
};
export default function WalletDetail(props) {
  const {
    T,
    formatLocalCurrency,
    getCurrency,
    convertToBTC,
    convertToLocalCurrency,
    currencies,
    setAlert,
    setLoading,
    user,
    isMobile,
    isCanConvertAffiliate,
  } = useApp();
  const navigate = useNavigate();
  const size = useWindowSize();

  const [searchParams] = useSearchParams();
  let { type, walletId, code } = {
    type: searchParams.get("type"),
    id: searchParams.get("id"),
    code: searchParams.get("code"),
    walletId: searchParams.get("walletId"),
    ...(useParams() || {}),
  };
  const [viewType, setViewType] = useState(type);
  const [wallet, setWallet] = useState({});
  const [wallets, setWallets] = useState([]);
  const [dexWallet, setDexWallet] = useState(null);
  const [isLoadingCreateDexWallet, setIsLoadingCreateDexWallet] = useState(false)
  const [isOpenModalDex, setIsOpenModalDex] = useState(false)
  const [form] = Form.useForm();
  const [modal, setModal] = useState(false);
  const [modalDeposit, setModalDeposit] = useState(false);
  const [visible, setVisible] = useState(false);
  const [detailBalanceModal, setDetailBalanceModal] = useState();
  const isOptionType = type === TYPE_WALLET_DETAIL.OPTION;
  const [configWeb3Wallet, setConfigWeb3Wallet] = useState(false);
  
  useEffect(() => {
    Promise.all([getSettingByCode('ENABLE_WALLET'), getSettingByCode('ENABLE_WALLET_MEMBER')])
      .then((response) => { 
        const enableWalletData = response[0]?.data?.data || null;
        const enableWalletMemberData = response[1]?.data?.data || null;
        if (enableWalletData) {
          if (enableWalletData.value === "0") {
            setConfigWeb3Wallet(false);
          } else if (enableWalletData.value === "2") {
            if (enableWalletMemberData && enableWalletMemberData.value.indexOf(user.email) !== -1) {
              setConfigWeb3Wallet(true)
            }else{
              setConfigWeb3Wallet(false)
            }
          } else {
            setConfigWeb3Wallet(true);
          }
        }else{
          setConfigWeb3Wallet(false);
        }
      }).catch(error => {
        setConfigWeb3Wallet(false);
      })
  }, [])

  useEffect(() => {
    setViewType(type);
    loadData().then((currencyCode) => {
      form.setFieldsValue({ from: currencyCode || "" });
    });
  }, [type, walletId]);

  const onBack = () => {
    navigate(`/wallet/?type=${isOptionType ? "option" : type}`);
  };

  const loadData = async () => {
    setLoading(true);
    let currentWallet = "";
    let result = {};
    if (type === TYPE_WALLET_DETAIL.GAMECURRENCYSGT) {
      result = await getWalletListSgt();
      if (result?.data?.data) {
        setWallet({
          id: result?.data?.data?.id,
          dog_food: result?.data?.data?.dogFood || 0,
          possible_convert_balance: result?.data?.data?.possibleConvertBalance || 0,
          freeze_dog_food: result?.data?.data?.freezeDogFood || 0,
          member_id: result?.data?.data?.memberId,
          address: result?.data?.data?.address,
          currency_type: result?.data?.data?.type,
          currency_code: "SGT",
          create_time: result?.data?.data?.createTime,
        });
        currentWallet = "SGT";
      }
    } else if (type === TYPE_WALLET_DETAIL.GAMECURRENCY) {
      result = await getWalletListSzt();
      if (result?.data?.data) {
        setWallet({
          id: result?.data?.data?.id,
          dog_food: result?.data?.data?.dogFood,
          possible_convert_balance: result?.data?.data?.possibleConvertBalance,
          freeze_dog_food: result?.data?.data?.freezeDogFood,
          member_id: result?.data?.data?.memberId,
          address: result?.data?.data?.address,
          currency_type: result?.data?.data?.type,
          currency_code: "SZT",
          create_time: result?.data?.data?.createTime,
        });
        currentWallet = "SZT";
      }
    } else if (type === TYPE_WALLET_DETAIL.OPTION) {
      result = await getWalletOptionDetail({code});
      if (result.status === 200) {
        const data = result?.data?.data || {};
        setWallet(data);
        currentWallet = data.currencyCode;
      }
    } else {
      result = await getWallet(walletId);
      if (result.status === 200) {
        const data = result?.data?.data?.wallet || {};
        setWallet(data);
        currentWallet = data.currency_code;
      }
      const resultDexWallet = await getDexWallet();
      console.log('loadData=>resultDexWallet=', resultDexWallet);
      if(resultDexWallet && resultDexWallet.data && resultDexWallet.data.data && resultDexWallet.data.data.public_address) {
        setDexWallet(resultDexWallet.data.data.public_address);
      }
    }

    const resultWalletList = await getWalletList();
    const resultSZT =
      type === TYPE_WALLET_DETAIL.GAMECURRENCY || type === TYPE_WALLET_DETAIL.GAMECURRENCYSGT
        ? result
        : await getWalletListSzt();
    let items = [];
    if (resultWalletList.status === 200) {
      items = resultWalletList?.data?.data?.wallets?.rows || [];
    }
    if (resultSZT?.data?.data) {
      items.push({
        id: resultSZT?.data?.data?.id,
        dog_food: resultSZT?.data?.data?.dogFood,
        possible_convert_balance: resultSZT?.data?.data?.possibleConvertBalance,
        freeze_dog_food: resultSZT?.data?.data?.freezeDogFood,
        member_id: resultSZT?.data?.data?.memberId,
        address: resultSZT?.data?.data?.address,
        currency_type: resultSZT?.data?.data?.type,
        currency_code: type === TYPE_WALLET_DETAIL.GAMECURRENCYSGT ? "SGT" : "SZT",
        create_time: resultSZT?.data?.data?.createTime,
      });
    }
    setWallets(items);
    setLoading(false);
    return currentWallet;
  };
  const onSgtWithdraw = () => {
    navigate(
      `/withdraw-sgt?type=gameCurrencySGT`
    );
  };
  const convertData = () => {
    return {
      wallet: {
        ...wallet,
        coin: wallet.currency_code,
        code: wallet.currency_code,
        cName: getNameByCode(wallet?.currency_code),
        coinName: T(
          wallet.currency_code !== 'SGT' ? `${getNameByCode(wallet?.currency_code) || ""} (${
            wallet.currency_code
          })`: `${
            wallet.currency_code
          }`
        ),
        amount: wallet.dog_food,
        amountText: `${formatCurrency(wallet?.dog_food || 0)} ${
          wallet.currency_code
        }`,
        local: convertToLocalCurrency(
          wallet.dog_food,
          wallet.currency_code,
          getCurrency()
        ),
        localText: formatLocalCurrency(
          roundNumber(
            convertToLocalCurrency(
              wallet.dog_food,
              wallet.currency_code,
              getCurrency()
            ) || 0,
            2
          )
        ),
        icon: `/assets/images/otc/crypto/${getCoinCodeImage(
          wallet?.currency_code?.toLowerCase() || "szt"
        )}.svg`,
      },
      rows: wallets.map((item, index) => {
        const data = {
          ...item,
          coin: item.currency_code,
          amount: item.dog_food,
          coinName: T(
            TYPE_WALLET_DETAIL.GAMECURRENCY
              ? "SZT"
              : `${getNameByCode(item?.currency_code)} (${item.currency_code})`
          ),
          btc: convertToBTC(item.dog_food, item.currency_code, getCurrency()),
          local: convertToLocalCurrency(
            item.dog_food,
            item.currency_code,
            getCurrency()
          ),
        };
        return data;
      }),
    };
  };

  const convertDataOption = () => {
    return {
      wallet: {
        ...wallet,
        coin: wallet.currencyCode,
        code: wallet.currencyCode,
        cName: getNameByCode(wallet?.currencyCode),
        coinName: T(
          `${getNameByCode(wallet?.currencyCode) || ""} (${
            wallet.currencyCode
          })`
        ),
        amount: wallet.originBalance,
        amountText: `${formatCurrency(wallet?.originBalance || 0)} ${
          wallet.currencyCode
        }`,
        local: convertToLocalCurrency(
          wallet.originBalance,
          wallet.currencyCode,
          getCurrency()
        ),
        localText: formatLocalCurrency(
          roundNumber(
            convertToLocalCurrency(
              wallet.originBalance,
              wallet.currencyCode,
              getCurrency()
            ) || 0,
            2
          )
        ),
        icon: `/assets/images/otc/crypto/${getCoinCodeImage(
          wallet?.currencyCode?.toLowerCase() || "szt"
        )}.svg`,
      },
      rows: wallets.map((item, index) => {
        const data = {
          ...item,
          coin: item.currency_code,
          amount: item.dog_food,
          coinName: T(
            TYPE_WALLET_DETAIL.GAMECURRENCY
              ? "SZT"
              : `${getNameByCode(item?.currency_code)} (${item.currency_code})`
          ),
          btc: convertToBTC(item.dog_food, item.currency_code, getCurrency()),
          local: convertToLocalCurrency(
            item.dog_food,
            item.currency_code,
            getCurrency()
          ),
        };
        return data;
      }),
    };
  };

  

  const onTransferWeb3 = (record) => {
    if ([TYPE_WALLET_DETAIL.CRYPTO].includes(viewType)) {
      navigate(
        `/transfer-web3?code=${
          wallet?.currency_code || ""
        }&walletId=${walletId}&type=${viewType}`
      );
    }
  };
  const onCreateWeb3Wallet = () => {
    if ([TYPE_WALLET_DETAIL.CRYPTO].includes(viewType)) {
      setIsLoadingCreateDexWallet(true);
      createDexWallet().then(async({data}) => {
        if (data.error.status){
          setDexWallet(data.data.address);
          setIsOpenModalDex(true)
        }else{
          Notification.error(T("Web3 wallet has been created."));
          if (data.error.message == "wallet_dex_already_exist") {
            const resultDexWallet = await getDexWallet();
            if(resultDexWallet && resultDexWallet.data && resultDexWallet.data.data && resultDexWallet.data.data.public_address) {
              setDexWallet(resultDexWallet.data.data.public_address);
            }
          }
        }
        setIsLoadingCreateDexWallet(false);
      }).catch((err) => {
        setIsLoadingCreateDexWallet(false);
        console.log("onCreateWeb3Wallet->err", err);
        Notification.error(T('Web3 wallet has been created.'))
      })
    }
  };

  const onWithDraw = (record) => {
    if ([TYPE_WALLET_DETAIL.CRYPTO, TYPE_WALLET_DETAIL.GAMECURRENCY].includes(viewType) || wallet?.can_auto_withdraw === 1) {
      navigate(
        `/withdraw?code=${
          wallet?.currency_code || ""
        }&walletId=${walletId}&type=${viewType}`
      );
    }
  };  
  
  const onTransactionHistory = (type) => {
    navigate(
      `/wallet-detail-history`
    );
  };

  const onConvert = (record) => {
    navigate(`/withdraw?code=${wallet?.currency_code || ""}&type=${viewType}`);
  };

  const getNameByCode = (code) => {
    return currencies.find((item) => item.code === code)?.name || "";
  };

  const value =
    type === TYPE_WALLET_DETAIL.OPTION
      ? convertDataOption()?.wallet
      : convertData()?.wallet || {};
  const renderCrypto = () => {
    return (
      <>
        <WalletDetailHeader>
          <DesktopContainer>
            <WalletDetailHeaderLeft>
              <WalletDetailHeaderLeftIcon>
                <img src={value?.icon} />
              </WalletDetailHeaderLeftIcon>
              <WalletDetailHeaderLeftContent>
                <BalanceContainer style={{ marginBottom: 0 }}>
                  <BalanceTitle style={{ marginBottom: 0 }}>
                    <BalanceText>
                      {value?.coinName === "undefined"
                        ? "----"
                        : value?.coinName}
                    </BalanceText>
                    {code === "ETH" && (
                      <Tooltip
                        trigger={size.width < 1023 ? "click" : "hover"}
                        onClick={(e) => e.stopPropagation()}
                        className="cursor-pointer"
                        color={"#EAF2FF"}
                        placement={size.width < 1023 ? "bottom" : "top"}
                        overlayClassName={"note-tooltip-4 text-left"}
                        title={
                          <div>
                            <div style={{ marginBottom: "5px" }}>
                              {T("・Including ETH converted from SZT balance")}
                            </div>
                            <div style={{ marginBottom: "5px" }}>
                              {T(
                                "・Rate ETH/USD will be get from CoinMarketCap (refresh every 30 minutes)"
                              )}
                            </div>
                            <div>
                              {T(
                                "・From this screen you can withdraw your ETH to your outside wallet"
                              )}
                            </div>
                          </div>
                        }
                      >
                        <span className="ml-[10px]">
                          <InfoTooltipIcon />
                        </span>
                      </Tooltip>
                    )}
                    {code.indexOf("SOTd") !== -1 && (
                      <Tooltip
                        trigger={size.width < 1023 ? "click" : "hover"}
                        onClick={(e) => e.stopPropagation()}
                        className="cursor-pointer"
                        color={"#EAF2FF"}
                        placement={size.width < 1023 ? "bottom" : "top"}
                        overlayClassName={"note-tooltip-4 text-left"}
                        title={
                          <div>
                            <div style={{ marginBottom: "5px" }}>
                              {T(
                                "・Including SOTds received from owning the Earner Avatar through specific periods."
                              )}
                            </div>
                            <div style={{ marginBottom: "5px" }}>
                              {T(
                                "・Rate SOTds/USD will be similar to rate SGT/USD which is get from CoinMarketCap (refresh every 30 minutes)"
                              )}
                            </div>
                            <div
                              dangerouslySetInnerHTML={{
                                __html: T(
                                  "・At the convertible term as noted in whitepaper the SOTds will be converted to the SOTs (erc-20) token with the same amount"
                                ),
                              }}
                            ></div>
                          </div>
                        }
                      >
                        <span className="ml-[10px]">
                          <InfoTooltipIcon />
                        </span>
                      </Tooltip>
                    )}
                    {code.indexOf("SOT") !== -1 &&
                      code.indexOf("SOTd") === -1 &&
                      code.indexOf("SOTa") === -1 && (
                        <Tooltip
                          trigger={size.width < 1023 ? "click" : "hover"}
                          onClick={(e) => e.stopPropagation()}
                          className="cursor-pointer"
                          color={"#EAF2FF"}
                          placement="bottom"
                          overlayClassName={"note-tooltip-2 text-left"}
                          title={
                            <div>
                              <div style={{ marginBottom: "5px" }}>
                                {T(
                                  "・Including SOTs received from take part in AI AVATAR affiliate/partner program"
                                )}
                              </div>
                              <div style={{ marginBottom: "5px" }}>
                                {T(
                                  "・Rate SOTs/USD will be similar to rate SGT/USD which is get from CoinMarketCap (refresh every 30 minutes)"
                                )}
                              </div>
                              <div
                                style={{ marginBottom: "5px" }}
                                dangerouslySetInnerHTML={{
                                  __html: T(
                                    "・At the convertible term as noted in whitepaper the SOTs can be used to swap for SGT"
                                  ),
                                }}
                              ></div>
                              <div>
                                {T(
                                  "・From this screen user can withdraw your SOTs to your outside wallet"
                                )}
                              </div>
                            </div>
                          }
                        >
                          <span className="ml-[10px]">
                            <InfoTooltipIcon />
                          </span>
                        </Tooltip>
                      )}
                    {code.indexOf("SOTa") !== -1 && (
                      <Tooltip
                        trigger={size.width < 1023 ? "click" : "hover"}
                        onClick={(e) => e.stopPropagation()}
                        className="cursor-pointer"
                        color={"#EAF2FF"}
                        placement={size.width < 1023 ? "bottom" : "top"}
                        overlayClassName={"note-tooltip-4 text-left"}
                        title={
                          <div>
                            <div style={{ marginBottom: "5px" }}>
                              {T(
                                "・Including SOTα received from buying subscription package"
                              )}
                            </div>
                            <div style={{ marginBottom: "5px" }}>
                              {T(
                                "・Rate SOTα/USD will be similar to rate SGT/USD which is get from CoinMarketCap (refresh every 30 minutes)"
                              )}
                            </div>
                            <div>
                              {T(
                                "・After one year of distribution, user can convert SOTα directly to SGT"
                              )}
                            </div>
                          </div>
                        }
                      >
                        <span className="ml-[10px]">
                          <InfoTooltipIcon />
                        </span>
                      </Tooltip>
                    )}
                  </BalanceTitle>
                  <BalanceValue>
                    {!visible ? (
                      <IconHideAmount width={isMobile ? 80 : 150} />
                    ) : (
                      <>
                        <BalanceValueBTC>{value?.amountText}</BalanceValueBTC>
                        <>
                          <div className="mx-[20px]">
                            <EqualIcon3 />
                          </div>
                          <BalanceValueEqual>
                            {value?.localText || ""}
                          </BalanceValueEqual>
                        </>
                      </>
                    )}
                    <BalanceIcon
                      className="mb-1"
                      onClick={() => setVisible(!visible)}
                    >
                      {visible ? <EyeIcon /> : <NoEyeIcon />}
                    </BalanceIcon>
                  </BalanceValue>
                </BalanceContainer>
              </WalletDetailHeaderLeftContent>
            </WalletDetailHeaderLeft>
          </DesktopContainer>
          <MobileContainer>
            <BalanceText className="flex items-center">
              {value?.coinName}
              {code === "ETH" && (
                <Tooltip
                  trigger={size.width < 1023 ? "click" : "hover"}
                  onClick={(e) => e.stopPropagation()}
                  className="cursor-pointer"
                  color={"#EAF2FF"}
                  placement={size.width < 1023 ? "bottom" : "top"}
                  overlayClassName={"note-tooltip-4 text-left"}
                  title={
                    <div>
                      <div style={{ marginBottom: "5px" }}>
                        {T("・Including ETH converted from SZT balance")}
                      </div>
                      <div style={{ marginBottom: "5px" }}>
                        {T(
                          "・Rate ETH/USD will be get from CoinMarketCap (refresh every 30 minutes)"
                        )}
                      </div>
                      <div>
                        {T(
                          "・From this screen you can withdraw your ETH to your outside wallet"
                        )}
                      </div>
                    </div>
                  }
                >
                  <span className="ml-[10px]">
                    <InfoTooltipIcon />
                  </span>
                </Tooltip>
              )}
              {code.indexOf("SOTd") !== -1 && (
                <Tooltip
                  trigger={size.width < 1023 ? "click" : "hover"}
                  onClick={(e) => e.stopPropagation()}
                  className="cursor-pointer"
                  color={"#EAF2FF"}
                  placement={size.width < 1023 ? "bottom" : "top"}
                  overlayClassName={"note-tooltip-4 text-left"}
                  title={
                    <div>
                      <div style={{ marginBottom: "5px" }}>
                        {T(
                          "・Including SOTds received from owning the Earner Avatar through specific periods."
                        )}
                      </div>
                      <div style={{ marginBottom: "5px" }}>
                        {T(
                          "・Rate SOTds/USD will be similar to rate SGT/USD which is get from CoinMarketCap (refresh every 30 minutes)"
                        )}
                      </div>
                      <div
                        dangerouslySetInnerHTML={{
                          __html: T(
                            "・At the convertible term as noted in whitepaper the SOTds will be converted to the SOTs (erc-20) token with the same amount"
                          ),
                        }}
                      ></div>
                    </div>
                  }
                >
                  <span className="ml-[10px]">
                    <InfoTooltipIcon />
                  </span>
                </Tooltip>
              )}
              {code.indexOf("SOT") !== -1 &&
                code.indexOf("SOTd") === -1 &&
                code.indexOf("SOTa") === -1 && (
                  <Tooltip
                    trigger={size.width < 1023 ? "click" : "hover"}
                    onClick={(e) => e.stopPropagation()}
                    className="cursor-pointer"
                    color={"#EAF2FF"}
                    placement="bottom"
                    overlayClassName={"note-tooltip-2 text-left"}
                    title={
                      <div>
                        <div style={{ marginBottom: "5px" }}>
                          {T(
                            "・Including SOTs received from take part in AI AVATAR affiliate/partner program"
                          )}
                        </div>
                        <div style={{ marginBottom: "5px" }}>
                          {T(
                            "・Rate SOTs/USD will be similar to rate SGT/USD which is get from CoinMarketCap (refresh every 30 minutes)"
                          )}
                        </div>
                        <div
                          style={{ marginBottom: "5px" }}
                          dangerouslySetInnerHTML={{
                            __html: T(
                              "・At the convertible term as noted in whitepaper the SOTs can be used to swap for SGT"
                            ),
                          }}
                        ></div>
                        <div>
                          {T(
                            "・From this screen user can withdraw your SOTs to your outside wallet"
                          )}
                        </div>
                      </div>
                    }
                  >
                    <span className="ml-[10px]">
                      <InfoTooltipIcon />
                    </span>
                  </Tooltip>
                )}
              {code.indexOf("SOTa") !== -1 && (
                <Tooltip
                  trigger={size.width < 1023 ? "click" : "hover"}
                  onClick={(e) => e.stopPropagation()}
                  className="cursor-pointer"
                  color={"#EAF2FF"}
                  placement={size.width < 1023 ? "bottom" : "top"}
                  overlayClassName={"note-tooltip-4 text-left"}
                  title={
                    <div>
                      <div style={{ marginBottom: "5px" }}>
                        {T(
                          "・Including SOTα received from buying subscription package"
                        )}
                      </div>
                      <div style={{ marginBottom: "5px" }}>
                        {T(
                          "・Rate SOTα/USD will be similar to rate SGT/USD which is get from CoinMarketCap (refresh every 30 minutes)"
                        )}
                      </div>
                      <div>
                        {T(
                          "・After one year of distribution, user can convert SOTα directly to SGT"
                        )}
                      </div>
                    </div>
                  }
                >
                  <span className="ml-[10px]">
                    <InfoTooltipIcon />
                  </span>
                </Tooltip>
              )}
            </BalanceText>
            <WalletDetailHeaderLeft style={{ marginTop: 0 }}>
              <WalletDetailHeaderLeftIcon>
                <img src={value?.icon} />
              </WalletDetailHeaderLeftIcon>
              <WalletDetailHeaderLeftContent>
                <BalanceContainer style={{ marginBottom: 0 }}>
                  {!visible ? (
                    <div className="flex items-center">
                      <IconHideAmount width={isMobile ? 80 : 150} />
                      {!visible && (
                        <BalanceIcon
                          className="mb-1"
                          onClick={() => setVisible(!visible)}
                        >
                          {visible ? <EyeIcon /> : <NoEyeIcon />}
                        </BalanceIcon>
                      )}
                    </div>
                  ) : (
                    <>
                      <BalanceTitle style={{ marginBottom: 0 }}>
                        <BalanceValueBTC className="flex items-center">
                          {value?.amountText}
                        </BalanceValueBTC>
                      </BalanceTitle>
                      <>
                        <BalanceValue>
                          <BalanceValueIcon>
                            <EqualIcon />
                          </BalanceValueIcon>
                          <BalanceValueEqual className="flex items-center">
                            {value?.localText}
                            <BalanceIcon
                              className="mb-1"
                              onClick={() => setVisible(!visible)}
                            >
                              {visible ? <EyeIcon /> : <NoEyeIcon />}
                            </BalanceIcon>
                          </BalanceValueEqual>
                        </BalanceValue>
                      </>
                    </>
                  )}
                </BalanceContainer>
              </WalletDetailHeaderLeftContent>
            </WalletDetailHeaderLeft>
          </MobileContainer>

          <WalletDetailHeaderRight style={{ marginTop: 0 }}>
            <ContainerTab style={{ marginBottom: 0, display: "flex", gap: 8 }}>
              {(viewType == TYPE_WALLET_DETAIL.CRYPTO && configWeb3Wallet) && <>
                { !dexWallet && <FormButton
                  className="black2 btn-transfer-web3"
                  height={52}
                  onClick={onCreateWeb3Wallet}
                  disabled={
                    viewType !== TYPE_WALLET_DETAIL.CRYPTO || isLoadingCreateDexWallet
                  }
                >
                  {T("Create web3 wallet")}
                </FormButton>}
                { dexWallet &&<FormButton
                  className="black2 btn-transfer-web3"
                  height={52}
                  onClick={onTransferWeb3}
                  disabled={
                    viewType !== TYPE_WALLET_DETAIL.CRYPTO
                  }
                >
                  {T("Transfer to Web3 Wallet")}
                </FormButton>
                }
              </>}
              <ContainerSubTab>
              {viewType === TYPE_WALLET_DETAIL.CRYPTO &&
                user.country_code !== "JP" && (
                  <TabItem
                    className={"version-3 full-width mb-half"}
                    style={{ marginRight: 0 }}
                    onClick={() => {
                      setModalDeposit(true);
                    }}
                  >
                    {T("Deposit")}
                  </TabItem>
                )}
              {viewType === TYPE_WALLET_DETAIL.CRYPTO && <FormButton
                height={52}
                width={175}
                paddingLeft={20}
                paddingRight={20}
                paddingBottom={16}
                paddingTop={16}
                className="primary2 mb-half"
                onClick={onWithDraw}
              >
                {T("Withdraw")}
              </FormButton>}
              
              </ContainerSubTab>
            </ContainerTab>
          </WalletDetailHeaderRight>
          {isOpenModalDex && <ModalCreateWalletSuccess 
            onClose={() => setIsOpenModalDex(false)} 
            onSubmit={() => onTransferWeb3()} 
          />}
        </WalletDetailHeader>
      </>
    );
  };

  const renderGameCurrency = () => {
    return (
      <>
        <WalletDetailHeader>
          <DesktopContainer>
            <WalletDetailHeaderLeft>
              <WalletDetailHeaderLeftIcon>
                <img src={value?.icon} />
              </WalletDetailHeaderLeftIcon>
              <WalletDetailHeaderLeftContent>
                <BalanceContainer style={{ marginBottom: 0 }}>
                  <BalanceTitle style={{ marginBottom: 15 }}>
                    <BalanceText>{value?.coinName}</BalanceText>
                    <Tooltip
                      trigger={size.width < 1023 ? "click" : "hover"}
                      onClick={(e) => e.stopPropagation()}
                      className="cursor-pointer"
                      color={"#EAF2FF"}
                      placement={size.width < 1023 ? "bottom" : "top"}
                      overlayClassName={"note-tooltip-4 text-left"}
                      title={
                        <div>
                          <div style={{ marginBottom: "5px" }}>
                            {T(
                              "・Including SZT earned from walking activities and SZT earned from affiliate commission"
                            )}
                          </div>
                          <div style={{ marginBottom: "5px" }}>
                            {T(
                              "・Rate USD/SZT will be fixed at 1 SZT = 10 USD"
                            )}
                          </div>
                          <div>
                            {T(
                              "・From this screen you can convert your SZT into Ethereum (ETH)"
                            )}
                          </div>
                        </div>
                      }
                    >
                      <span className="ml-[10px]">
                        <InfoTooltipIcon />
                      </span>
                    </Tooltip>
                    {/* {type === TYPE_WALLET_DETAIL.GAMECURRENCY && (
                      <InfoIcon
                        onClick={() => setDetailBalanceModal(true)}
                        style={{
                          opacity: 0.8,
                          marginLeft: 6,
                          marginBottom: 3,
                          cursor: "pointer",
                        }}
                      />
                    )} */}

                    {/* <TagComponent className="ml-4">
                      {T(
                        type === TYPE_WALLET_DETAIL.COMMISSION
                          ? "Affiliate"
                          : "Walk-to-earn"
                      )}
                    </TagComponent> */}
                  </BalanceTitle>
                  <BalanceValue>
                    {!visible ? (
                      <IconHideAmount width={isMobile ? 80 : 150} />
                    ) : (
                      <>
                        <BalanceValueBTC>{value?.amountText}</BalanceValueBTC>
                        <BalanceValueIcon>
                          <EqualIcon3 />
                        </BalanceValueIcon>
                        <BalanceValueEqual>
                          {value?.localText}
                        </BalanceValueEqual>
                      </>
                    )}
                    <BalanceIcon
                      className="mb-1"
                      onClick={() => setVisible(!visible)}
                    >
                      {visible ? <EyeIcon /> : <NoEyeIcon />}
                    </BalanceIcon>
                  </BalanceValue>
                </BalanceContainer>
              </WalletDetailHeaderLeftContent>
            </WalletDetailHeaderLeft>
          </DesktopContainer>
          <MobileContainer>
            <BalanceText className="flex items-center">
              {value?.coinName}
              <Tooltip
                trigger={size.width < 1023 ? "click" : "hover"}
                onClick={(e) => e.stopPropagation()}
                className="cursor-pointer"
                color={"#EAF2FF"}
                placement={size.width < 1023 ? "bottom" : "top"}
                overlayClassName={"note-tooltip-4 text-left"}
                title={
                  <div>
                    <div style={{ marginBottom: "5px" }}>
                      {T(
                        "・Including SZT earned from walking activities and SZT earned from affiliate commission"
                      )}
                    </div>
                    <div style={{ marginBottom: "5px" }}>
                      {T("・Rate USD/SZT will be fixed at 1 SZT = 10 USD")}
                    </div>
                    <div>
                      {T(
                        "・From this screen you can convert your SZT into Ethereum (ETH)"
                      )}
                    </div>
                  </div>
                }
              >
                <span className="ml-[10px]">
                  <InfoTooltipIcon />
                </span>
              </Tooltip>
              {/* {type === TYPE_WALLET_DETAIL.GAMECURRENCY && (
                <InfoIcon
                  onClick={() => setDetailBalanceModal(true)}
                  style={{
                    opacity: 0.8,
                    marginLeft: 6,
                    marginBottom: 3,
                    cursor: "pointer",
                  }}
                />
              )} */}
              {/* <TagComponent className="ml-4">
                {T(
                  type === TYPE_WALLET_DETAIL.COMMISSION
                    ? "Affiliate"
                    : "Walk-to-earn"
                )}
              </TagComponent> */}
            </BalanceText>
            <WalletDetailHeaderLeft style={{ marginTop: 0 }}>
              <WalletDetailHeaderLeftIcon>
                <img src={value?.icon} />
              </WalletDetailHeaderLeftIcon>
              <WalletDetailHeaderLeftContent>
                <BalanceContainer style={{ marginBottom: 0 }}>
                  {!visible ? (
                    <div className="flex items-center">
                      <IconHideAmount width={isMobile ? 80 : 150} />
                      <BalanceIcon
                        className="mb-1"
                        onClick={() => setVisible(!visible)}
                      >
                        {visible ? <EyeIcon /> : <NoEyeIcon />}
                      </BalanceIcon>
                    </div>
                  ) : (
                    <>
                      <BalanceTitle style={{ marginBottom: 0 }}>
                        <BalanceValueBTC>{value?.amountText}</BalanceValueBTC>
                      </BalanceTitle>
                      <BalanceValue>
                        <BalanceValueIcon>
                          <EqualIcon />
                        </BalanceValueIcon>
                        <BalanceValueEqual className="flex items-center">
                          {value?.localText}
                          <BalanceIcon
                            className="mb-1"
                            onClick={() => setVisible(!visible)}
                          >
                            {visible ? <EyeIcon /> : <NoEyeIcon />}
                          </BalanceIcon>
                        </BalanceValueEqual>
                      </BalanceValue>
                    </>
                  )}
                </BalanceContainer>
              </WalletDetailHeaderLeftContent>
            </WalletDetailHeaderLeft>
          </MobileContainer>

          <WalletDetailHeaderRight style={{ marginTop: 45 }}>
            <ContainerTab style={{ marginBottom: 0 }}>
              <FormButton
                disabled={
                  type === TYPE_WALLET_DETAIL.COMMISSION &&
                  !isCanConvertAffiliate
                }
                height={52}
                width={175}
                paddingLeft={20}
                paddingRight={20}
                paddingBottom={16}
                paddingTop={16}
                onClick={onConvert}
                className="primary2"
              >
                {T("Convert")}
              </FormButton>
            </ContainerTab>
          </WalletDetailHeaderRight>
        </WalletDetailHeader>
      </>
    );
  };
  const renderGameCurrencySGT = () => {
    return (
      <>
        <WalletDetailHeader>
          <DesktopContainer>
            <WalletDetailHeaderLeft>
              <WalletDetailHeaderLeftIcon>
                <img src={value?.icon} />
              </WalletDetailHeaderLeftIcon>
              <WalletDetailHeaderLeftContent>
                <BalanceContainer style={{ marginBottom: 0 }}>
                  <BalanceTitle style={{ marginBottom: 15 }}>
                    <BalanceText>{value?.coinName}</BalanceText>
                    <Tooltip
                      trigger={size.width < 1023 ? "click" : "hover"}
                      onClick={(e) => e.stopPropagation()}
                      className="cursor-pointer"
                      color={"#EAF2FF"}
                      placement={size.width < 1023 ? "bottom" : "top"}
                      overlayClassName={"note-tooltip-10 text-left"}
                      title={
                        <div>
                          <div style={{ marginBottom: "5px" }}>
                          ・{T(
                              "Includes SGT earned from walking activities."
                            )}
                          </div>
                          <div style={{ marginBottom: "5px" }}>
                          ・{T(
                              "The SGT/USD rate will be estimated base on the real-time exchange rate."
                            )}
                          </div>
                          <div>
                          ・{T(
                              "You can withdraw SGT to your AI Avatar Web3 wallet from this screen."
                            )}
                          </div>
                        </div>
                      }
                    >
                      <span className="ml-[10px]">
                        <InfoTooltipIcon />
                      </span>
                    </Tooltip>
                    {/* {type === TYPE_WALLET_DETAIL.GAMECURRENCY && (
                      <InfoIcon
                        onClick={() => setDetailBalanceModal(true)}
                        style={{
                          opacity: 0.8,
                          marginLeft: 6,
                          marginBottom: 3,
                          cursor: "pointer",
                        }}
                      />
                    )} */}

                    {/* <TagComponent className="ml-4">
                      {T(
                        type === TYPE_WALLET_DETAIL.COMMISSION
                          ? "Affiliate"
                          : "Walk-to-earn"
                      )}
                    </TagComponent> */}
                  </BalanceTitle>
                  <BalanceValue>
                    {!visible ? (
                      <IconHideAmount width={isMobile ? 80 : 150} />
                    ) : (
                      <>
                        <BalanceValueBTC>{value?.amountText}</BalanceValueBTC>
                        <BalanceValueIcon>
                          <EqualIcon3 />
                        </BalanceValueIcon>
                        <BalanceValueEqual>
                          {value?.localText}
                        </BalanceValueEqual>
                      </>
                    )}
                    <BalanceIcon
                      className="mb-1"
                      onClick={() => setVisible(!visible)}
                    >
                      {visible ? <EyeIcon /> : <NoEyeIcon />}
                    </BalanceIcon>
                  </BalanceValue>
                </BalanceContainer>
              </WalletDetailHeaderLeftContent>
            </WalletDetailHeaderLeft>
          </DesktopContainer>
          <MobileContainer>
            <BalanceText className="flex items-center">
              {value?.coinName}
              <Tooltip
                trigger={size.width < 1023 ? "click" : "hover"}
                onClick={(e) => e.stopPropagation()}
                className="cursor-pointer"
                color={"#EAF2FF"}
                placement={size.width < 1023 ? "bottom" : "top"}
                overlayClassName={"note-tooltip-10 text-left"}
                title={
                  <div>
                    <div style={{ marginBottom: "5px" }}>
                    ・{T(
                        "Includes SGT earned from walking activities."
                      )}
                    </div>
                    <div style={{ marginBottom: "5px" }}>
                    ・{T("The SGT/USD rate will be estimated base on the real-time exchange rate.")}
                    </div>
                    <div>
                    ・{T(
                        "You can withdraw SGT to your AI Avatar Web3 wallet from this screen."
                      )}
                    </div>
                  </div>
                }
              >
                <span className="ml-[10px]">
                  <InfoTooltipIcon />
                </span>
              </Tooltip>
              {/* {type === TYPE_WALLET_DETAIL.GAMECURRENCY && (
                <InfoIcon
                  onClick={() => setDetailBalanceModal(true)}
                  style={{
                    opacity: 0.8,
                    marginLeft: 6,
                    marginBottom: 3,
                    cursor: "pointer",
                  }}
                />
              )} */}
              {/* <TagComponent className="ml-4">
                {T(
                  type === TYPE_WALLET_DETAIL.COMMISSION
                    ? "Affiliate"
                    : "Walk-to-earn"
                )}
              </TagComponent> */}
            </BalanceText>
            <WalletDetailHeaderLeft style={{ marginTop: 0 }}>
              <WalletDetailHeaderLeftIcon>
                <img src={value?.icon} />
              </WalletDetailHeaderLeftIcon>
              <WalletDetailHeaderLeftContent>
                <BalanceContainer style={{ marginBottom: 0 }}>
                  {!visible ? (
                    <div className="flex items-center">
                      <IconHideAmount width={isMobile ? 80 : 150} />
                      <BalanceIcon
                        className="mb-1"
                        onClick={() => setVisible(!visible)}
                      >
                        {visible ? <EyeIcon /> : <NoEyeIcon />}
                      </BalanceIcon>
                    </div>
                  ) : (
                    <>
                      <BalanceTitle style={{ marginBottom: 0 }}>
                        <BalanceValueBTC>{value?.amountText}</BalanceValueBTC>
                      </BalanceTitle>
                      <BalanceValue>
                        <BalanceValueIcon>
                          <EqualIcon />
                        </BalanceValueIcon>
                        <BalanceValueEqual className="flex items-center">
                          {value?.localText}
                          <BalanceIcon
                            className="mb-1"
                            onClick={() => setVisible(!visible)}
                          >
                            {visible ? <EyeIcon /> : <NoEyeIcon />}
                          </BalanceIcon>
                        </BalanceValueEqual>
                      </BalanceValue>
                    </>
                  )}
                </BalanceContainer>
              </WalletDetailHeaderLeftContent>
            </WalletDetailHeaderLeft>
          </MobileContainer>

          <WalletDetailHeaderRight style={{ marginTop: 45 }}>
            <ContainerTab style={{ marginBottom: 0 }}>
              <FormButton
                height={52}
                paddingLeft={20}
                paddingRight={20}
                paddingBottom={16}
                paddingTop={16}
                onClick={onSgtWithdraw}
                className="primary2 lg:w-[175px] w-full"
              >
                {T("Withdraw")}
              </FormButton>
            </ContainerTab>
          </WalletDetailHeaderRight>
        </WalletDetailHeader>
      </>
    );
  };
  const renderScreen = () => {
    if (
      viewType === TYPE_WALLET_DETAIL.CRYPTO ||
      viewType === TYPE_WALLET_DETAIL.OPTION
    )
      return renderCrypto();
    if (
      viewType === TYPE_WALLET_DETAIL.GAMECURRENCY
    )
      return renderGameCurrency();
    if (
      viewType === TYPE_WALLET_DETAIL.GAMECURRENCYSGT
    )
      return renderGameCurrencySGT();
    return null;
  };

  const renderTitle = () => {
    if (viewType === TYPE_WALLET_DETAIL.CRYPTO) return "Crypto Detail";
    if (
      viewType === TYPE_WALLET_DETAIL.GAMECURRENCY
    )
      return "Credit detail";
    if (
      viewType === TYPE_WALLET_DETAIL.GAMECURRENCYSGT
    )
      return "SGT Credit detail";
    if (viewType === TYPE_WALLET_DETAIL.OPTION) return "Option Detail";
    return "Wallet details";
  };

  return value?.code ? (
    <Container>
      <ContainerView>
        <div className="flex justify-between items-center">
          <TitleWithBackWallet mb={40} title={T(renderTitle())} onClick={onBack} />
          <div
            className="cursor-pointer mb-[40px] w-[26px] lg:w-[32px]"
            onClick={() => onTransactionHistory(type)}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="100%"
              height="32"
              viewBox="0 0 32 32"
              fill="none"
            >
              <path
                d="M16 10.6665V15.9998L19.3333 19.3332"
                stroke="#1C274C"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <path
                d="M7.47219 7.47219L6.76508 6.76508L7.47219 7.47219ZM5.78368 9.16069L4.78369 9.16572C4.78645 9.71408 5.2303 10.1579 5.77866 10.1607L5.78368 9.16069ZM9.17272 10.1777C9.725 10.1805 10.175 9.73505 10.1777 9.18278C10.1805 8.6305 9.73505 8.18054 9.18278 8.17776L9.17272 10.1777ZM6.76661 5.7616C6.76384 5.20932 6.31388 4.76386 5.7616 4.76664C5.20932 4.76941 4.76386 5.21937 4.76664 5.77165L6.76661 5.7616ZM5.10214 14.3799C5.17714 13.8327 4.79437 13.3284 4.24721 13.2534C3.70004 13.1784 3.19567 13.5611 3.12067 14.1083L5.10214 14.3799ZM25.1496 6.85036C20.0561 1.75677 11.825 1.70519 6.76508 6.76508L8.17929 8.17929C12.4448 3.91382 19.4095 3.9386 23.7354 8.26457L25.1496 6.85036ZM6.85036 25.1496C11.9439 30.2432 20.175 30.2948 25.2349 25.2349L23.8207 23.8207C19.5552 28.0862 12.5905 28.0614 8.26457 23.7354L6.85036 25.1496ZM25.2349 25.2349C30.2948 20.175 30.2432 11.9439 25.1496 6.85036L23.7354 8.26457C28.0614 12.5905 28.0862 19.5552 23.8207 23.8207L25.2349 25.2349ZM6.76508 6.76508L5.07657 8.45359L6.49079 9.8678L8.1793 8.17929L6.76508 6.76508ZM5.77866 10.1607L9.17272 10.1777L9.18278 8.17776L5.78871 8.16071L5.77866 10.1607ZM6.78367 9.15567L6.76661 5.7616L4.76664 5.77165L4.78369 9.16572L6.78367 9.15567ZM3.12067 14.1083C2.58543 18.0132 3.83189 22.1312 6.85036 25.1496L8.26457 23.7354C5.70381 21.1747 4.64884 17.687 5.10214 14.3799L3.12067 14.1083Z"
                fill="#1C274C"
              />
            </svg>
          </div>
        </div>
        {renderScreen()}
        <Divider
          style={{
            borderColor: isMobile ? "rgba(0, 0, 0, 0.20)" : "#fff",
            marginBottom: 0,
            marginTop: 12,
          }}
        />
        <TransactionHistory />
      </ContainerView>

      {modal ? (
        <ModalPhoneVerify
          onClose={(value) => {
            setModal(null);
            if (value) {
              setAlert({
                type: value,
                text:
                  value === "success"
                    ? T("Successfully verified your phone number")
                    : "",
              });
            }
            if (value === "success") {
            }
          }}
          value={modal}
        />
      ) : null}

      {modalDeposit && (
        <ModalDeposit value={value} onClose={() => setModalDeposit(false)} />
      )}

      {detailBalanceModal ? (
        <DetailBalance
          type={type}
          wallet={wallet}
          id={walletId}
          onClose={() => {
            setDetailBalanceModal(null);
          }}
        />
      ) : null}
    </Container>
  ) : null;
}
